<template>
  <crud-form
    v-model="payload"
    page-title="Atualizar taxas do estabelecimento"
    :request-class="proxyRequest"
    navigate-back-route="contacard.submodules.list"
    :total-group="1"
  >
    <template slot="group-1">
      <form-group>
        <v-row>
          <v-col cols="9">
            <input-radio
              v-model="payload.comAntecipacao"
              :options="comAntecipacaoOptions"
              label="Antecipar"
              row
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-mask
              v-model="payload.documento"
              label="Documento do estabelecimento"
              :rules="[requiredRule]"
              outlined
              required
            />
          </v-col>
          <v-col cols="6">
            <input-money
              v-model="payload.custoLocacao"
              label="Custo locação"
              outlined
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-select
              v-model="payload.tabelaDePrecoId"
              label="Tabela de preço"
              :loading="priceLoading"
              :items="prices"
              :rules="[requiredRule]"
              required
              outlined
            />
          </v-col>
          <v-col cols="6">
            <input-select
              v-model="payload.faixaId"
              label="Faixa de preço"
              :loading="ratesLoading"
              :items="rates"
              :rules="[requiredRule]"
              required
              outlined
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import EstablishmentService from './EstablishmentService';
import AdqTablePriceService from './AdqTablePriceService';
import AdqTaxService from './AdqTaxService';

export default {
  name: 'EstablishmentForm',
  components: { CrudForm, FormGroup },
  mixins: [RequestSelectMixin, RulesMixin],
  data: () => ({
    requestClass: EstablishmentService,
    tablePriceService: AdqTablePriceService,
    taxService: AdqTaxService,
    prices: [],
    rates: [],
    priceLoading: false,
    ratesLoading: false,
    comAntecipacaoOptions: [
      {
        label: 'Sim',
        value: true,
      },
      {
        label: 'Não',
        value: false,
        color: 'primary',
      },
    ],
    payload: {
      documento: '',
      tabelaDePrecoId: '',
      faixaId: '',
      comAntecipacao: false,
      custoLocacao: '',
    },
  }),
  computed: {
    proxyRequest() {
      const { documento, custoLocacao, ...rest } = this.payload;
      return {
        save: () => this.requestClass.update({
          ...rest,
          custoLocacao: Number(custoLocacao),
          documento: String(documento).replace(/[^0-9]/g, ''),
        }),
      };
    },
  },
  created() {
    this.list();
  },
  methods: {
    list() {
      this.listPrices();
      this.listRates();
    },
    listPrices() {
      this.handlePriceLoading();
      this.serviceCall(
        this.tablePriceService.list(
          this.makeParams(),
        ),
        this.setDataOptions('prices', 'descricao'),
        'Falha ao buscar tabelas de preço!',
        this.handlePriceLoading,
      );
    },
    handlePriceLoading() {
      this.priceLoading = !this.priceLoading;
    },
    listRates() {
      this.handleRateLoading();
      this.serviceCall(
        this.taxService.list(
          this.makeParams(),
        ),
        this.setDataOptions('rates', 'descricao'),
        'Falha ao buscar faixas de preços!',
        this.handleRateLoading,
      );
    },
    handleRateLoading() {
      this.ratesLoading = !this.ratesLoading;
    },
  },
};
</script>
